import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { AdminComponent } from './admin.component';
import { FormsModule } from '@angular/forms';
import '@wdpr/button';
import '@wdpr/input';
import '@wdpr/toast';

@NgModule({
    declarations: [AdminComponent],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        TranslateModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AdminModule { }
